<template>
  <div class="purchase_body">
    <div class="xiangqing" v-for="cu of currlist">
      <div class="tupian"><img :src="cu.covermap"></div>
      <div class="wenzi">
        <div class="shangp">{{cu.titles}}</div>
        <div class="qian">¥{{cu.fee}}</div>
      </div>
    </div>

    <van-coupon-cell
      :coupons="coupons"
      :chosen-coupon="chosenCoupon"
      @click="showList = true"
    />
    <!-- 优惠券列表 -->
    <van-popup
      v-model="showList"
      round
      position="bottom"
      style="height: 90%; padding-top: 4px;"
    >
      <van-coupon-list
        :coupons="coupons"
        :chosen-coupon="chosenCoupon"
        :disabled-coupons="disabledCoupons"
        @change="onChange"
        @exchange="onExchange"
      />
    </van-popup>

    <!--      <div class="jieshao">-->
    <!--        <dt>购买后解锁以下课程</dt>-->
    <!--        <dd>所有视频</dd>-->
    <!--        <dd>所有音频</dd>-->
    <!--        <dd>所有学习资料包</dd>-->
    <!--      </div>-->

    <div class="jieshaojine">
      <van-cell-group>
        <van-cell title="套餐购买" :value="'¥'+jine"/>
        <van-cell title="抵扣" :value="'¥'+(coupons.length!=0?chosenCoupon!=-1?coupons[chosenCoupon].valueDesc:0:0)"/>
        <van-cell title="实付金额"
                  :value="'¥'+(jine-parseFloat((coupons.length!=0?chosenCoupon!=-1?coupons[chosenCoupon].valueDesc:0:0)))"/>
      </van-cell-group>
    </div>


    <van-popup v-model="show1" position="bottom" :style="{ height: '45%' }">
      <div class="zhifu">
        <h3>确认支付</h3>
        <div class="qian">
          {{'¥'+(jine-parseFloat((coupons.length!=0?chosenCoupon!=-1?coupons[chosenCoupon].valueDesc:0:0)))}}
        </div>
        <van-divider/>
        <div class="zhifufangshi">支付方式</div>
        <van-radio-group v-model="radio">
          <van-cell-group>
            <van-cell title="微信支付" clickable @click="radio = '1'">
              <template #right-icon>
                <van-radio name="1"/>
              </template>
            </van-cell>
            <van-cell title="余额支付" clickable @click="radio = '2'">
              <template #right-icon>
                <van-radio name="2"/>
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
        <van-button type="warning" size="large" style="margin-top: 10px;" @click="zhifu">确认支付</van-button>
      </div>
    </van-popup>


    <van-submit-bar
      :price="(jine-parseFloat((coupons.length!=0?chosenCoupon!=-1?coupons[chosenCoupon].valueDesc:0:0)))*100"
      button-text="提交订单" @submit="tijiao(coupons)"/>
  </div>
</template>

<script>
  import {Toast} from 'vant';
  import {Dialog} from 'vant';
  import wx from 'weixin-js-sdk'

  const coupon = {
    available: 1,
    condition: '无使用门槛\n最多优惠12元',
    reason: '',
    value: 150,
    name: '优惠券名称',
    startAt: 1489104000,
    endAt: 1514592000,
    valueDesc: '1.5',
    unitDesc: '元',
  };
  export default {
    name: "purchase",
    data() {
      return {
        radio: '1',
        show1: false,
        showList: false,
        chosenCoupon: -1,
        coupons: [],
        disabledCoupons: [],
        jine: '',
        biaoti: '',
        ordid: '',
        valueDe: '',
        indexs: '',
        zhekou: '',
        tupian: '',
        ids: '',
        sta: '',
        currlist: "",

      }
    },
    created() {
      this.getdata()
      this.getcity()
    },
    methods: {
      onChange(index) {
        this.showList = false;
        this.chosenCoupon = index;
        console.log(this.chosenCoupon, 213213)
      },
      onExchange(code) {
        this.coupons.push(coupon);
        // console.log(coupon.value,213314)
      },
      zhifu() {
        if (this.radio == 2) {
          this.myrequest({
            url: '/client/paymentorder.action',
            types: 'post',
            data: {
              token: this.$store.state.token,
              orderid: this.ordid,
              code: 2,
            },
            succ: (res) => {
              Toast.success('支付成功');
              this.show1 = false
              this.$router.go(-1)
            },
            errs: (msg) => {
              Toast.fail(msg);
            }
          })
        } else if (this.radio == 1) {
          this.myrequest({
            url: '/client/wxpaymentorder.action',
            types: 'post',
            data: {
              // token:this.$store.state.token
              orderid: this.ordid,
              code: 2,
            },
            succ: (res) => {
              wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: this.$store.state.appid, // 必填，公众号的唯一标识
                timestamp: this.$store.state.timestamp, // 必填，生成签名的时间戳
                nonceStr: this.$store.state.nonceStr, // 必填，生成签名的随机串
                signature: this.$store.state.signature,// 必填，签名
                jsApiList: ['chooseImage', 'updateAppMessageShareData', 'updateTimelineShareData', 'chooseWXPay'] // 必填，需要使用的JS接口列表
              });
              wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
                wx.chooseWXPay({
                  timestamp: res.data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                  nonceStr: res.data.nonceStr, // 支付签名随机串，不长于 32 位
                  package: res.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                  signType: 'MD5', // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                  paySign: res.data.paySign, // 支付签名
                  success: function (res) {
                    // this.$router.push({ path:'/Courses'})
                    window.location.href = '/Courses'
                    // window.location.href = '/index/Mine/confirmOrder/orderDetails?ids=' + this.orderId
                  },
                  cancel: function (res) {
                    Toast.success('已取消支付');
                    // alert(JSON.stringify(res))
                  },
                  fail: function (res) {
                    // alert(JSON.stringify(res))
                  }
                });
              });

            },
            errs: (msg) => {

            }
          })
        }

      },
      getcity() {
        this.myrequest({
          url: '/client/getpackageinfo.action',
          types: 'get',
          data: {
            // token:this.$store.state.token
            id: this.$route.query.id
          },
          succ: (res) => {
            console.log(res)
            this.currlist = res.currlist
            this.jine = res.info.fee
            this.biaoti = res.info.titles
            this.tupian = res.data[0].covermap
          },
          errs: (msg) => {

          }
        })
      },
      getdata() {
        this.myrequest({
          url: '/client/getcoupon.action',
          types: 'get',
          data: {
            token: this.$store.state.token,
            cid: this.$route.query.id,
            code: 2,
          },
          succ: (res) => {
            res.wxlist != null ? this.disabledCoupons = res.wxlist : []
            res.yxlist != null ? this.coupons = res.yxlist : []
          },
          errs: (msg) => {
            console.log(msg)

          }
        })
      },
      tijiao() {
        if (this.chosenCoupon == -1) {
          this.myrequest({
            url: '/client/addpackagecurriculumorder.action',
            types: 'post',
            data: {
              token: this.$store.state.token,
              cid: this.$route.query.id,
              code: 2,
            },
            succ: (res) => {
              this.show1 = true
              this.ordid = res.orderid
            },
            errs: (msg) => {
              if (msg == "您已经下过单了,请前去[我的-组合课程列表]查看") {
                Dialog.confirm({
                  title: '提示',
                  message: msg,
                })
                  .then(() => {
                    // on confirm
                    this.$router.push({path: '/couress'})
                  })
                  .catch(() => {

                  });
              } else if (msg == "您暂未绑定手机号码! 请先前去[我的]绑定手机号") {
                Dialog.confirm({
                  title: '提示',
                  message: msg + "44444444",
                })
                  .then(() => {
                    // on confirm
                    this.$router.push({path: '/Mobile'})
                  })
                  .catch(() => {

                  });
              } else {
                Toast.fail(msg);
              }

            }
          })
        } else if (this.chosenCoupon != -1) {
          this.myrequest({
            url: '/client/addpackagecurriculumorder.action',

            types: 'post',
            data: {
              token: this.$store.state.token,
              cid: this.$route.query.id,
              couponivs: this.coupons[this.chosenCoupon].id,
              code: 2,
            },
            succ: (res) => {
              this.show1 = true
              this.ordid = res.orderid
              this.sta = res.status
            },
            errs: (msg) => {
              if (msg == "您已经下过单了,请前去[我的-课程列表]查看") {
                Dialog.confirm({
                  title: '提示',
                  message: msg,
                })
                  .then(() => {
                    // on confirm
                    this.$router.push({path: '/couress'})
                  })
                  .catch(() => {

                  });
              } else if (msg = "您暂未绑定手机号码! 请先前去[我的]绑定手机号") {
                Dialog.confirm({
                  title: '提示',
                  message: msg,
                })
                  .then(() => {
                    // on confirm
                    this.$router.push({path: '/Mobile'})
                  })
                  .catch(() => {

                  });
              } else {
                Toast.fail(msg);
              }

              // if(this.sta!=0){
              //     Dialog.confirm({
              //         title: '提示',
              //         message: msg,
              //     })
              //         .then(() => {
              //             // on confirm
              //             this.$router.push({path: '/Courses'})
              //         })
              //         .catch(() => {
              //
              //         });
              // }else{
              //     Toast.fail(msg);
              // }


            }
          })
        }

      }
    }
  }
</script>

<style scoped lang="stylus">
  .purchase_body {
    position: absolute;
    width 100%;
    background-color #f1f1f1;
    height 100%;

    .jieshaojine {
      >>> .van-cell__value {
        font-weight 500;
        color red
      }
    }


    .zhifu {
      width 100%;

      h3 {
        text-align center;
        color #333;
        font-weight 500
      }

      .zhifufangshi {
        margin-left 10px;
        margin-bottom 10px;
        font-size 14px;
      }

      .qian {
        text-align center;
        font-size 14px;
        font-weight 500
      }

      >>> .van-button--large {
        width 50%;
        margin auto;
        display block
      }

      >>> .van-button--warning {
        background-color red
      }
    }

    .xiangqing {
      width 95%;
      background-color #fff;
      height auto;
      overflow hidden
      margin 10px auto;

      .tupian {
        float left;
        margin-bottom 5px;

        img {
          margin 10px
          width 100px;

          /*border-radius 10px;*/
        }
      }

      .wenzi {
        float left

        .shangp {
          color: #000;
          font-weight 500;
          margin-left 15px;
          margin-top 15px;
          font-size 15px;
          overflow: hidden; //超出的文本隐藏
          text-overflow: ellipsis; //溢出用省略号显示
          white-space: nowrap; //溢出不换行
          width 200px
        }

        .qian {
          color red;
          margin-left 15px;
          margin-top 20px;
          font-weight 400
        }

        .jifen {
          color: rgba(255, 31, 46, 0.44)
          margin-left 10px;
          margin-top 10px;
        }
      }

    }

    .jieshao {
      width 95%;
      margin 10px auto;

      dt {
        font-size 14px;
        font-weight 500
        color #333
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ziyuanku/purchases.vue